// Create an order page
import React, { JSX, useState } from 'react';
import Container from "react-bootstrap/Container";
import {Stack} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from "react-router-dom";
import { CgClose } from "react-icons/cg";
import {setHasRewaredSelected, updateSelectedReward} from 'app/store/slices/rewardsSlice';
import { isRewardExpired } from 'app/features/RewardsHome/RewardsUtility';
import LABELS from 'app/shared/constants/Literals';
import { updateRewardSelectedOnPage } from 'store/slices/tOrderSlice';
import {RewardsDetails} from './types/RewardsDetails';
import {RootState} from '../../store';

type Props = {
    isCartPage: boolean;
};
const RewardsBanner: React.FC<Props> = ({ isCartPage }):
    JSX.Element => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        selectedReward,
    } = useSelector((state: RootState) => state.rewards);

    const { pickUpDate } = useSelector((state: RootState) => state.stores);

    const [showReward, setShowReward] = useState(false);

    const handleReward = () => {
        setShowReward(!showReward);
    };

    const handleRemoveReward = () => {
        dispatch(updateSelectedReward({} as RewardsDetails));
        setShowReward(!showReward);
        dispatch(setHasRewaredSelected(false));
        dispatch(updateRewardSelectedOnPage(false));
        navigate("/category");
    };
    const rewardExpired = isRewardExpired(selectedReward, pickUpDate);

    return (
        <div>
            <Modal
                centered
                keyboard={false}
                backdrop="static"
                show={showReward}
                size="sm"
                style={{ zIndex: '1300' }}
            >
                <Modal.Body className="font-sub">
                    Are you sure you want remove this reward from your order?
                    <br />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="secondary-button reward-button"
                        variant="secondary"
                        onClick={handleReward}
                    >
                        No
                    </Button>
                    <Button
                        className="order-now-card-button reward-button"
                        variant="primary"
                        onClick={handleRemoveReward}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* eslint-disable-next-line no-nested-ternary */}
            <Container className="w-auto border-2 rounded-2 rewardBannerCard pt-1 pb-1">
                {!isCartPage && (
                    <Stack direction="horizontal" gap={3}>
                        <Stack gap={3} className="text-center">
                            <div className="d-flex justify-content-start flex-column">
                                <span className="font-main text-uppercase">{`You have selected a ${selectedReward?.title} reward!`}</span>
                                {
                                    rewardExpired ? (
                                        <span className="font-sub errorText" aria-live="assertive" role="alert">{LABELS.REWARDS.rewardExpiredError}</span>
                                    ) : (
                                        <span className="font-sub">{LABELS.REWARDS.rewardSelectProduct}</span>
                                    )
                                }
                            </div>
                        </Stack>
                        <CgClose
                            className="modalCloseBtn"
                            size={25}
                            onClick={handleReward}
                            aria-label="close"
                            role="button"
                            tabIndex={0}
                            onKeyDown={(event: React.KeyboardEvent<SVGElement>) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    event.preventDefault();
                                    handleReward();
                                }
                            }}
                        />
                    </Stack>
                )}
                {isCartPage && (
                    <Stack direction="horizontal" gap={3}>
                        <Stack gap={3}>
                            <div className="d-flex justify-content-start flex-column pt-1 pb-1">
                                <span className="font-main text-uppercase">{`You added a ${selectedReward?.title} reward!`}</span>
                                {
                                    rewardExpired ? (
                                        <span className="font-sub errorText" aria-live="assertive" role="alert">{LABELS.REWARDS.rewardExpiredError}</span>
                                    ) : (
                                        <span className="font-sub">{LABELS.REWARDS.checkoutDiscount}</span>
                                    )
                                }
                            </div>
                        </Stack>
                        <CgClose
                            className="modalCloseBtn"
                            size={25}
                            onClick={handleReward}
                            aria-label="close"
                            role="button"
                            tabIndex={0}
                            onKeyDown={(event: React.KeyboardEvent<SVGElement>) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    event.preventDefault();
                                    handleReward();
                                }
                            }}
                        />
                    </Stack>
                )}
            </Container>
        </div>
    );
};

export default RewardsBanner;
